import { Observable } from 'rxjs';
import { ILocality } from 'src/app/core/models/api';

export abstract class ILocalityService {
  abstract getLocalities(): Observable<Array<ILocality>>;
}
